import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ShieldCheck, LogOut, Terminal } from 'lucide-react';
import { CONFIG } from '../mock/mock';
import { api } from '../lib/api';

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const current = api.getCurrent();
  const isDashboard = location.pathname.startsWith('/dashboard');

  const handleLogout = () => {
    api.logout();
    navigate('/');
  };

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#050915]/70 border-b border-cyan-500/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="relative">
            <div className="h-9 w-9 rounded-lg glass flex items-center justify-center glow-cyan">
              <Terminal className="h-5 w-5 text-cyan-300" />
            </div>
          </div>
          <div className="leading-tight">
            <div className="font-display text-[13px] sm:text-sm tracking-[0.25em] font-semibold text-white">{CONFIG.siteName}</div>
            <div className="text-[10px] sm:text-[11px] tracking-[0.3em] text-cyan-300/70">{CONFIG.tagline}</div>
          </div>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-3">
          {!isDashboard && (
            <Link to="/verify" className="btn-ghost px-4 py-2 rounded-md text-sm font-medium tracking-wider hidden sm:inline-flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-cyan-300" />
              VERIFY
            </Link>
          )}
          {current ? (
            <>
              <span className="hidden sm:inline text-xs text-cyan-300/80 font-mono">ID: {current}</span>
              <button onClick={handleLogout} className="btn-ghost px-3 py-2 rounded-md text-sm inline-flex items-center gap-2">
                <LogOut className="h-4 w-4" /> Logout
              </button>
            </>
          ) : (
            !isDashboard && (
              <Link to="/login" className="btn-ghost px-4 py-2 rounded-md text-sm font-medium tracking-wider inline-flex items-center gap-2 sm:hidden">
                LOGIN
              </Link>
            )
          )}
        </nav>
      </div>
    </header>
  );
}
